import React from 'react';
import moment from 'moment';
import { DeactivationReasonModalContainer } from './styled';
import { t } from 'i18next';
import { EngineDeactivationReasonEnum } from '@/constants/engine-deactivation-reason';

interface DeactivationReasonModalProps {
  isOpen: boolean;
  setIsDeactivationModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  deactivationData: {
    comment: string;
    reason: string | EngineDeactivationReasonEnum;
    date: Date;
    user: string;
  };
}

export const DeactivationReasonModal: React.FC<DeactivationReasonModalProps> = ({
  isOpen,
  setIsDeactivationModalOpen,
  deactivationData,
}) => {
  const handleOk = () => {
    setIsDeactivationModalOpen(false);
  };

  return (
    <DeactivationReasonModalContainer
      title={t('deactivationReason')}
      open={isOpen}
      onOk={handleOk}
      onCancel={() => setIsDeactivationModalOpen(false)}
      okText={t('Close')}
      cancelText={t('cancel')}
      centered
      cancelButtonProps={{ hidden: true }}
    >
      <div className="deactivation-details">
        <div className="detail-row">
          <span>{t('deactivatedBy')}</span> {deactivationData.user}
        </div>
        <div className="detail-row">
          <span>{t('dateTime')}</span> {moment(deactivationData.date).format('MMMM D, YYYY h:mm A')}
        </div>
        <div>
          <strong>{t('reason')}:</strong>
          <br />
          {deactivationData.reason}
        </div>
        {deactivationData.comment && (
          <div>
            <strong>{t('comment')}:</strong> <br /> {deactivationData.comment}
          </div>
        )}
      </div>
    </DeactivationReasonModalContainer>
  );
};
